import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button } from '$partials/ui/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const TagCloudSmall = ({
    tags = null,
    theme = ''
}) => {
    // state
    const [ isExpanded, setIsExpanded ] = useState(false);

    // render
    return (
        <ul className='flex flex-wrap gap-10'>
            {tags.map((tag, idx) => {
                if (idx > 0 && !isExpanded) {
                    return null;
                }

                if (idx > 9) {
                    return null;
                }

                return (
                    <li key={idx}>
                        <Button
                            as='a'
                            className='pill-button pill-button--white-black'
                            href={tag.url}
                            key={idx}>
                            {tag.title}
                        </Button>
                    </li>
                );
            }).filter(Boolean)}

            {(tags.length > 1 && !isExpanded) && (
                <li>
                    <Button
                        className='pill-button pill-button--white-black'
                        onClick={setIsExpanded.bind(this, true)}>
                        &hellip;
                    </Button>
                </li>
            )}
        </ul>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    tags: PropTypes.array.isRequired,
    theme: PropTypes.string
};

TagCloudSmall.propTypes = propTypes;

export default TagCloudSmall;
